(function () {
  var STORAGE_KEY = "skei_active_ad_promo";
  var CACHE_BUSTER = "v7";
  var INJECTED_CLASS = "skei-promo-collection-product";
  var HIDDEN_DUPLICATE_ATTR = "data-skei-hidden-promo-duplicate";
  var RENDERED_SIGNATURE_ATTR = "data-skei-promo-rendered-signature";
  var RENDERING_ATTR = "data-skei-promo-rendering";

  function now() {
    return new Date().getTime();
  }

  function getUrlParam(name) {
    var params = new URLSearchParams(window.location.search);
    return params.get(name);
  }

  function getConfig() {
    var raw = window.SKEI_AD_PROMOS || {};

    return {
      promos: raw.promos || {},
      adIdMap: raw.adIdMap || {}
    };
  }

  function getPromoByPromoId(promoId) {
    var config = getConfig();

    if (!promoId || !config.promos[promoId]) {
      return null;
    }

    return {
      promo_id: promoId,
      promo: config.promos[promoId]
    };
  }

  function getPromoByAdId(adId) {
    var config = getConfig();

    if (!adId || !config.adIdMap) {
      return null;
    }

    var matchedPromoId = null;

    Object.keys(config.adIdMap).some(function (promoId) {
      var adIds = config.adIdMap[promoId];

      if (typeof adIds === "string") {
        adIds = adIds.split(",").map(function (item) {
          return item.trim();
        });
      }

      if (!Array.isArray(adIds)) {
        return false;
      }

      if (adIds.indexOf(adId) !== -1) {
        matchedPromoId = promoId;
        return true;
      }

      return false;
    });

    if (!matchedPromoId) {
      return null;
    }

    return getPromoByPromoId(matchedPromoId);
  }

  function getExpiryTimestamp() {
    return now() + 7 * 24 * 60 * 60 * 1000;
  }

  function savePromo(promoId, sourceKey, sourceValue, promo) {
    if (!promoId || !promo || !promo.products || !promo.products.length) return;

    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          promo_id: promoId,
          source_key: sourceKey || "",
          source_value: sourceValue || "",
          name: promo.name || "",
          products: promo.products,
          expires_at: getExpiryTimestamp()
        })
      );
    } catch (e) {}
  }

  function getSavedPromo() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;

      var promo = JSON.parse(raw);

      if (!promo.expires_at || promo.expires_at < now()) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }

      if (!promo.products || !promo.products.length) return null;

      return promo;
    } catch (e) {
      return null;
    }
  }

  function capturePromoFromUrl() {
    var directPromoId = getUrlParam("skei_promo");
    var adId = getUrlParam("ad_id");

    if (directPromoId) {
      var directMatch = getPromoByPromoId(directPromoId);

      if (directMatch) {
        savePromo(
          directMatch.promo_id,
          "skei_promo",
          directPromoId,
          directMatch.promo
        );
        return;
      }
    }

    if (adId) {
      var adMatch = getPromoByAdId(adId);

      if (adMatch) {
        savePromo(
          adMatch.promo_id,
          "ad_id",
          adId,
          adMatch.promo
        );
      }
    }
  }

  function uniqueArray(items) {
    var seen = {};
    var result = [];

    items.forEach(function (item) {
      if (!item || seen[item]) return;
      seen[item] = true;
      result.push(item);
    });

    return result;
  }

  function productItemToHandle(item) {
    if (!item) return null;
    if (typeof item === "string") return item;
    if (item.handle) return item.handle;
    return null;
  }

  function getPromoHandles(promo) {
    return uniqueArray(
      (promo.products || [])
        .map(productItemToHandle)
        .filter(Boolean)
    );
  }

  function getRootUrl() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }

    return "/";
  }

  function makeUniqueId() {
    return Date.now() + "-" + Math.random().toString(36).slice(2, 10);
  }

  function fetchProductCard(handle) {
    return fetch(
      getRootUrl() +
        "products/" +
        encodeURIComponent(handle) +
        "?view=skei-promo-card&v=" +
        CACHE_BUSTER,
      {
        credentials: "same-origin"
      }
    )
      .then(function (response) {
        if (!response.ok) throw new Error("Product card not found: " + handle);
        return response.text();
      })
      .then(function (html) {
        html = html.trim();

        if (!html || html.indexOf("product-item") === -1) {
          throw new Error("Invalid product card HTML: " + handle);
        }

        if (html.indexOf("data-skei-product-collections") === -1) {
          throw new Error("Missing collection data on product card: " + handle);
        }

        return html.replaceAll("UNIQUE_ID", makeUniqueId());
      });
  }

  function normalizeHandleFromHref(href) {
    if (!href || href.indexOf("/products/") === -1) return null;

    try {
      var url = new URL(href, window.location.origin);
      var parts = url.pathname.split("/products/");
      if (!parts[1]) return null;

      return decodeURIComponent(parts[1].split("/")[0]).trim();
    } catch (e) {
      return null;
    }
  }

  function getCardHandle(card) {
    var explicitHandle = card.getAttribute("data-skei-promo-handle");

    if (explicitHandle) {
      return explicitHandle;
    }

    var links = card.querySelectorAll('a[href*="/products/"]');

    for (var i = 0; i < links.length; i++) {
      var handle = normalizeHandleFromHref(links[i].getAttribute("href"));
      if (handle) return handle;
    }

    return null;
  }

  function getCardCollections(card) {
    var raw = card.getAttribute("data-skei-product-collections") || "";

    return raw
      .split(",")
      .map(function (item) {
        return item.trim();
      })
      .filter(Boolean);
  }

  function cardBelongsToCollection(card, collectionHandle) {
    var collections = getCardCollections(card);
    return collections.indexOf(collectionHandle) !== -1;
  }

  function htmlToProductCard(html, handle) {
    var wrapper = document.createElement("div");
    wrapper.innerHTML = html;

    var card = wrapper.querySelector(".product-item");

    if (!card) return null;

    card.classList.add(INJECTED_CLASS);
    card.setAttribute("data-skei-promo-handle", handle);
    card.setAttribute("data-skei-promo-injected", "true");

    return card;
  }

  function resetHiddenDuplicates(grid) {
    grid.querySelectorAll("[" + HIDDEN_DUPLICATE_ATTR + "]").forEach(function (card) {
      card.style.display = "";
      card.removeAttribute(HIDDEN_DUPLICATE_ATTR);
    });
  }

  function removeInjected(grid) {
    grid.querySelectorAll("." + INJECTED_CLASS).forEach(function (card) {
      card.remove();
    });
  }

  function hideDuplicates(grid, handles) {
    var handleMap = {};

    handles.forEach(function (handle) {
      handleMap[handle] = true;
    });

    Array.prototype.slice.call(grid.querySelectorAll(".product-item")).forEach(function (card) {
      if (card.classList.contains(INJECTED_CLASS)) return;

      var handle = getCardHandle(card);
      if (!handle || !handleMap[handle]) return;

      card.style.display = "none";
      card.setAttribute(HIDDEN_DUPLICATE_ATTR, "true");
    });
  }

  function insertCardsAtTop(grid, cards) {
    if (!cards.length) return;

    var fragment = document.createDocumentFragment();

    cards.forEach(function (card) {
      fragment.appendChild(card);
    });

    var firstProduct = Array.prototype.slice.call(grid.children).find(function (child) {
      return child.classList && child.classList.contains("product-item");
    });

    if (firstProduct) {
      grid.insertBefore(fragment, firstProduct);
    } else {
      grid.insertBefore(fragment, grid.firstChild);
    }
  }

  function wakeLazyImages(root) {
    root.querySelectorAll(".lazy-image img").forEach(function (img) {
      var figure = img.closest(".lazy-image");
      if (!figure) return;

      if (img.complete) {
        figure.classList.add("lazyloaded");
        figure.classList.add("lazy-image--revealed");
      }
    });
  }

  function initializePromoQuickBuyFallback(root) {
    if (!root) return;

    root.querySelectorAll("." + INJECTED_CLASS).forEach(function (card) {
      if (card.getAttribute("data-skei-quick-buy-fallback-ready") === "true") return;

      card.setAttribute("data-skei-quick-buy-fallback-ready", "true");

      var variants = card.querySelector("product-variants");
      var form = card.querySelector("form");
      var hiddenInput = form ? form.querySelector('input[name="id"]') : null;
      var button = card.querySelector("[data-js-product-add-to-cart]");
      var buttonText = card.querySelector("[data-js-product-add-to-cart-text]");

      if (!variants || !form || !hiddenInput || !button || !buttonText) return;

      function getAddToCartText() {
        if (
          window.KROWN &&
          KROWN.settings &&
          KROWN.settings.locales &&
          KROWN.settings.locales.products_add_to_cart_button
        ) {
          return KROWN.settings.locales.products_add_to_cart_button;
        }

        return "In den Warenkorb";
      }

      function getSoldOutText() {
        if (
          window.KROWN &&
          KROWN.settings &&
          KROWN.settings.locales &&
          KROWN.settings.locales.products_sold_out_variant
        ) {
          return KROWN.settings.locales.products_sold_out_variant;
        }

        return "Ausverkauft";
      }

      function getVariantRequiredText() {
        if (
          window.KROWN &&
          KROWN.settings &&
          KROWN.settings.locales &&
          KROWN.settings.locales.products_variant_required
        ) {
          return KROWN.settings.locales.products_variant_required;
        }

        return "Zuerst Größe wählen";
      }

      function getAllVariantInputs() {
        return Array.prototype.slice.call(
          variants.querySelectorAll('input[type="radio"][data-variant-id]')
        );
      }

      function hasAnyAvailableVariant() {
        return getAllVariantInputs().some(function (input) {
          return input.getAttribute("data-available") === "true";
        });
      }

      function getSelectedInput() {
        return (
          variants.querySelector('input[type="radio"]:checked') ||
          variants.querySelector('input[type="radio"][data-selected]')
        );
      }

      function setButtonEnabled(variantId) {
        hiddenInput.value = variantId;

        button.classList.remove("disabled");
        form.classList.remove("disabled-cart");
        form.classList.remove("unavailable-variant");

        buttonText.textContent = getAddToCartText();
      }

      function setButtonDisabledRequired() {
        button.classList.add("disabled");
        form.classList.add("disabled-cart");
        form.classList.add("unavailable-variant");

        buttonText.innerHTML =
          getAddToCartText() +
          '<br><span class="button__subtext">(' +
          getVariantRequiredText() +
          ")</span>";
      }

      function setButtonSoldOut() {
        button.classList.add("disabled");
        form.classList.add("disabled-cart");
        form.classList.add("unavailable-variant");

        buttonText.textContent = getSoldOutText();
      }

      function updateFromSelection() {
        if (!hasAnyAvailableVariant()) {
          setButtonSoldOut();
          return;
        }

        var selectedInput = getSelectedInput();

        if (!selectedInput) {
          setButtonDisabledRequired();
          return;
        }

        var variantId = selectedInput.getAttribute("data-variant-id");
        var available = selectedInput.getAttribute("data-available");

        if (!variantId) {
          setButtonDisabledRequired();
          return;
        }

        if (available === "false") {
          setButtonSoldOut();
          return;
        }

        setButtonEnabled(variantId);
      }

      variants.addEventListener("change", function (event) {
        var target = event.target;

        if (!target || !target.matches('input[type="radio"]')) return;

        variants.querySelectorAll('input[type="radio"]').forEach(function (input) {
          input.removeAttribute("data-selected");
          input.removeAttribute("checked");
        });

        target.setAttribute("data-selected", "");
        target.setAttribute("checked", "checked");

        updateFromSelection();
      });

      variants.addEventListener("click", function (event) {
        var input = event.target.closest('input[type="radio"]');

        if (!input) return;

        window.setTimeout(function () {
          input.checked = true;
          input.setAttribute("data-selected", "");
          updateFromSelection();
        }, 0);
      });

      form.addEventListener(
        "submit",
        function (event) {
          updateFromSelection();

          if (button.classList.contains("disabled")) {
            event.preventDefault();
            event.stopPropagation();
            return false;
          }
        },
        true
      );

      updateFromSelection();
    });
  }

  function resetPromoVariantSliders(root) {
    if (!root) return;

    window.setTimeout(function () {
      root.querySelectorAll("." + INJECTED_CLASS + " css-slider").forEach(function (slider) {
        if (typeof slider.resetSlider === "function") {
          slider.resetSlider(false, false);
        }
      });
    }, 150);
  }

  function makeSignature(collectionHandle, promoHandles) {
    return collectionHandle + "::" + promoHandles.join("|");
  }

  function renderCollectionGrid(grid, promo) {
    if (!grid || !promo) return;

    if (grid.getAttribute(RENDERING_ATTR) === "true") {
      return;
    }

    var collectionHandle = grid.getAttribute("data-skei-collection-handle");
    if (!collectionHandle) return;

    var promoHandles = getPromoHandles(promo);
    if (!promoHandles.length) return;

    var signature = makeSignature(collectionHandle, promoHandles);

    if (grid.getAttribute(RENDERED_SIGNATURE_ATTR) === signature) {
      return;
    }

    grid.setAttribute(RENDERING_ATTR, "true");

    Promise.all(
      promoHandles.map(function (handle) {
        return fetchProductCard(handle)
          .then(function (html) {
            return htmlToProductCard(html, handle);
          })
          .catch(function () {
            return null;
          });
      })
    )
      .then(function (cards) {
        cards = cards.filter(Boolean);

        var matchingCards = cards.filter(function (card) {
          return cardBelongsToCollection(card, collectionHandle);
        });

        var matchingHandles = matchingCards
          .map(getCardHandle)
          .filter(Boolean);

        resetHiddenDuplicates(grid);
        removeInjected(grid);

        if (!matchingCards.length) {
          grid.removeAttribute(RENDERED_SIGNATURE_ATTR);
          grid.removeAttribute(RENDERING_ATTR);
          return;
        }

        insertCardsAtTop(grid, matchingCards);
        hideDuplicates(grid, matchingHandles);
        wakeLazyImages(grid);
        initializePromoQuickBuyFallback(grid);
        resetPromoVariantSliders(grid);

        grid.setAttribute(RENDERED_SIGNATURE_ATTR, signature);
        grid.removeAttribute(RENDERING_ATTR);

        window.dispatchEvent(new Event("resize"));
      })
      .catch(function () {
        grid.removeAttribute(RENDERING_ATTR);
      });
  }

  function initCollectionPromo() {
    capturePromoFromUrl();

    var promo = getSavedPromo();
    if (!promo) return;

    document.querySelectorAll("[data-skei-promo-collection-grid]").forEach(function (grid) {
      renderCollectionGrid(grid, promo);
    });
  }

  function debounce(fn, wait) {
    var timeout;

    return function () {
      clearTimeout(timeout);
      timeout = setTimeout(fn, wait);
    };
  }

  var debouncedInit = debounce(initCollectionPromo, 150);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCollectionPromo);
  } else {
    initCollectionPromo();
  }

  document.addEventListener("shopify:section:load", debouncedInit);

  document.addEventListener("click", function (event) {
    var target = event.target;

    if (!target) return;

    if (
      target.closest("[data-js-facet-input]") ||
      target.closest("[data-js-sortby-selector]") ||
      target.closest(".facets") ||
      target.closest(".pagination")
    ) {
      debouncedInit();
    }
  });

  window.addEventListener("popstate", debouncedInit);
})();